import SliderDataZoomView from 'echarts/lib/component/dataZoom/SliderZoomView';
import type { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import type { Displayables, DvSliderDataZoomModel, MoveHandleOffset } from './type';
import { isValidNumericValue } from './util';

// @ts-ignore
const originRenderHandleMethod = SliderDataZoomView.prototype._renderHandle as () => void;

function $renderHandle(
  moveHandleOffset?: MoveHandleOffset,
  size?: number[],
  moveZone?: Displayables['moveZone']
) {
  if (!moveHandleOffset || !moveZone || !(size && size.length)) {
    return;
  }
  if (!isValidNumericValue(moveHandleOffset)) {
    return;
  }
  const half = 0.5;
  moveZone.attr({
    shape: {
      y: size[1] * half - moveHandleOffset
    }
  });
}

// @ts-ignore
SliderDataZoomView.prototype._renderHandle = function renderHandle() {
  const dvMoveHandleOffset = (this?.dataZoomModel as DvSliderDataZoomModel)?.get(
    'dvMoveHandleOffset'
  );
  // @ts-ignore
  const size = this._size as number[];
  originRenderHandleMethod.call(this);
  // @ts-ignore
  $renderHandle(dvMoveHandleOffset, size, (this?._displayables as Displayables)?.moveZone);
};

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('afterinit', () => {});
}
